import { render } from "./ProductReviews.vue?vue&type=template&id=6a0ba0a4&scoped=true"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"

import "./ProductReviews.vue?vue&type=style&index=0&id=6a0ba0a4&lang=css"
import "./ProductReviews.vue?vue&type=style&index=1&id=6a0ba0a4&lang=scss&scoped=true"
import "./ProductReviews.vue?vue&type=style&index=2&id=6a0ba0a4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0ba0a4"]])

export default __exports__